import React from 'react';
import {
  TextField,
  Box,
  Typography,
  Paper,
  Alert,
} from '@mui/material';
import { Email as EmailIcon } from '@mui/icons-material';

interface EmailConfigFieldsProps {
  incomingEmailAddress: string;
  isLoading: boolean;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

export const EmailConfigFields: React.FC<EmailConfigFieldsProps> = ({
  incomingEmailAddress,
  isLoading,
  onChange,
}) => {
  return (
    <Box>
      <Typography variant="h6" gutterBottom>
        Email-based News Collection
      </Typography>
      
      <Alert severity="info" sx={{ mb: 3 }}>
        This method allows Location Station to collect news content from emails sent to a monitored email address.
        Configure the email address from which news content will be sent.
      </Alert>
      
      <Paper elevation={0} variant="outlined" sx={{ p: 3, bgcolor: 'background.default', mb: 3 }}>
        <Typography variant="subtitle1" gutterBottom fontWeight="medium">
          Email Configuration
        </Typography>
        
        <TextField
          fullWidth
          required
          name="emailAddress"
          label="Email Address"
          type="email"
          value={incomingEmailAddress}
          onChange={onChange}
          placeholder="news@example.com"
          helperText="Enter the email address from which news content will be sent"
          InputProps={{
            startAdornment: (
              <EmailIcon sx={{ mr: 1, color: 'text.secondary' }} />
            ),
          }}
          sx={{ mb: 2 }}
        />
      </Paper>
      
      <Typography variant="subtitle1" gutterBottom>
        How Email Collection Works
      </Typography>
      
      <Typography variant="body2" paragraph>
        1. Location Station monitors incoming emails from the specified address
      </Typography>
      
      <Typography variant="body2" paragraph>
        2. When a new email arrives, the system automatically extracts article content
      </Typography>
      
      <Typography variant="body2" paragraph>
        3. The extracted content is processed and added to your news feed
      </Typography>
      
      <Typography variant="body2">
        Make sure the email address is configured to send news content in a consistent format for best results.
      </Typography>
    </Box>
  );
};

export default EmailConfigFields;